import React from "react";
import * as subscriptionService from "../../actions/subscription.actions";
import { useUser } from "../../context/UserContext";
import { useApiResponse } from "../../context/ApiResponseContext";
import { verifyUser } from "../../actions/auth.actions";
import {
  LOGIN_PAGE,
  SERVER_DOWN,
  SESSION_TOKEN_STORAGE_NAME,
} from "../../Constants";

export default function SubscriptionItem({
  name,
  price,
  priceLookupKey,
  perks,
}) {
  const perksList = JSON.parse(perks);
  const [user] = useUser();
  const [, setApiResponse] = useApiResponse();

  const getTickIcon = () => {
    return (
      <i
        class="fa-solid fa-circle-check paddingright20"
        style={{ color: "green" }}
      ></i>
    );
  };

  const getCrossIcon = () => {
    return (
      <i
        class="fa-solid fa-circle-xmark paddingright20"
        style={{ color: "red" }}
      ></i>
    );
  };

  const verifyUserIsValid = async () => {
    const response = await verifyUser();

    if (!response) {
      console.log(SERVER_DOWN);
      return;
    }

    if (!response.data.success) {
      localStorage.removeItem(SESSION_TOKEN_STORAGE_NAME);
      window.location.href = `${LOGIN_PAGE}?redirect_to=${window.location.pathname}`;
      return false;
    }
    return true;
  };

  const handleSubscriptionChosen = async (e) => {
    const isValidUser = await verifyUserIsValid();
    if (isValidUser) {
      const createCheckoutInfo = {
        email_address: user.email_address,
        price_lookup_key: priceLookupKey,
      };

      const response = await subscriptionService.createCheckout(
        createCheckoutInfo
      );

      if (response.data.success) {
        window.location.href = response.data.url;
      }

      if (!response.data.success) {
        setApiResponse({ checkoutError: response.data.message });
      }
    }
  };

  return (
    <div onClick={handleSubscriptionChosen} className="subscription-item">
      <div>
        <div>
          <h1>{name}</h1>
          <h2>
            <i>£{price.toFixed(2)}/month</i>
          </h2>
          <h5 className="font-weight-normal">
            (£{(price / 30).toFixed(2)}/day)
          </h5>
        </div>

        <div>
          {perksList.map((perk, key) => {
            return (
              <h3 key={key}>
                {perk.included ? getTickIcon() : getCrossIcon()}
                {perk.name}
              </h3>
            );
          })}
        </div>
      </div>
    </div>
  );
}
